export default "__VITE_ASSET__CVQmwslI__"